<!-- Translated: no -->
<template>
  <div class="language-switcher" v-if="SITE_CONFIG.language_switcher === true || ($store.state.isOnSite && SITE_CONFIG.language_switcher === 'onsite')">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/css/flag-icon.min.css" />

    <div class="component row" v-if="type === 'row'">
      <div class="title">
        <b>Välj språk</b>
        <span>Select language</span>
      </div>
      <div class="languages">
        <div :class="{language: true, active: (lang.value === selectedLanguage.value || !pickedLanguage)}" v-for="lang in languages" @click="setLanguage(lang)">
          <div class="flag" :style="'background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + lang.flag + '.svg)'" />
        </div>
      </div>
    </div>

    <div class="component dropdown" v-if="type === 'dropdown'">
      <div class="title" v-if="showTitle">
        <b>Select your language</b>
      </div>

      <div class="max-width">
        <Dropdown
          :options="languages"
          :validated="selectedLanguage && selectedLanguage.value"
          :value="selectedLanguage.value"
          :label="label"
          :with-background="true"
          @changed="changedLanguage"
          :bold-label="true"
          type="language"
          :allow-empty="false"
          >
        </Dropdown>
      </div>
    </div>

  </div>
</template>

<script>
import API from '@/classes/API';
import Dropdown from '@/components/components/Dropdown';

import moment from 'moment';

export default {
  props: {
    type: {
    },
    showTitle: {
      default: true,
    },
  },
  components: {
    Dropdown,
  },
  data() {
    return {
      languages: [],
      pickedLanguage: false,
      selectedLanguage: {},
    };
  },
  computed: {
    label() {
      if (this.selectedLanguage && this.selectedLanguage.value) {
        return '<div class="flag" style="background-image:url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + this.selectedLanguage.flag + '.svg);"></div> ' + (this.selectedLanguage.title); // eslint-disable-line
      }
      return 'Select language';
    },
  },
  beforeMount() {
    this.SITE_CONFIG.languages.full.forEach((lang) => {
      this.languages.push(lang);
    });

    const lang = this.$i18n.locale;
    this.selectedLanguage = this.languages.filter(item => item.value === lang)[0];
  },
  methods: {
    async setLanguage(lang) {
      this.selectedLanguage = lang;
      this.$emit('clickedlanguage', lang.value);

      localStorage.setItem('language', lang.value);
      moment.locale(lang.value);

      const data = await API.get('translations');
      try {
        this.$i18n.setLocaleMessage(lang.value, data.translations);
      } catch (e) {
        console.log(e);
      }

      window.SITE_CONFIG.translations = data.translations;

      try {
        this.$i18n.locale = lang.value;
      } catch (e) {
        console.log(e);
      }

      document.querySelector('html').setAttribute('lang', lang.value);

      this.pickedLanguage = true;
      this.$emit('pickedlanguage', lang.value);
    },
    async changedLanguage(lang) {
      await this.setLanguage(lang);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.component.row
  .title
    color white
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    b
      margin-bottom: 4px
    span
      margin-bottom: 0

  .languages
    display: flex;
    margin-top 20px
    margin-bottom 20px
    .language
      padding 5px
      background-color: rgba(255, 255, 255, 0.2)
      margin 15px
      cursor: pointer;
      transition: all 0.2s
      opacity: 0.4;
      &.active
        opacity: 1;
      &:hover
        background-color: rgba(255, 255, 255, 0.5)
      .flag
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        height: 28px
        width: 40px

.component.dropdown
  text-align: center
  margin-bottom: 25px
  .title
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 0
    font-size: 9px;
    b
      margin-bottom: 4px
    span
      margin-bottom: 0

.max-width
  width 150px
  display: inline-block;

</style>



// WEBPACK FOOTER //
// LanguageSwitcher.vue?780ee56d